// extracted by mini-css-extract-plugin
module.exports = {"stepTitle":"step-title-module--stepTitle--2aFJ5","stepText":"step-title-module--stepText--1vfQW","stepNumber":"step-title-module--stepNumber--FjQw6"};